import {DarkThemeColors, HighContrastThemeColors, LightThemeColors} from './Colors';

export const LightTheme = {
  dark: false,
  colors: LightThemeColors.colors,
  gradients: LightThemeColors.gradients,
};

export const DarkTheme = {
  dark: true,
  colors: DarkThemeColors.colors,
  gradients: DarkThemeColors.gradients,
};

export const HighContrastTheme = {
  dark: false,
  colors: HighContrastThemeColors.colors,
  gradients: HighContrastThemeColors.gradients,
};
